/* =========================================================
   ZEUS SHOP MENU V6 -- Phase 1 shell behaviours
   Standalone vanilla JS. NOT coupled to theme.js / navigation-drawer (D-T2).
   - open / close, Escape, focus restore to the LIVE trigger (SC 2.1.2 / 2.4.3)
   - focus trap: visibleFocusables() recomputed on every Tab (filters [hidden] + offsetParent);
     recaptures stray focus and never lets Tab escape the modal.
   - COORDINATED scroll lock via the theme's .lock class on <html>: released only when no
     Impact drawer is still open. Cart opened from the takeover bar = close-then-open.
     NOTE (Phase 2): close-then-open is load-bearing -- the shop owns .lock directly while
     Impact ref-counts the SAME class (DialogElement #lockLayerCount). They do not race in
     Phase 1 (empty body, header covered at z 960, bar cart closes the shop first). When
     Phase 2 adds an in-overlay drawer/quick-add, switch to the theme's DialogElement base
     (managed lock + inert) per review-report nice-to-have 3, or a shared lock token.
   - Open is delegated on [aria-controls="zeus-shop-overlay"] so it survives header re-render.
   - Guards the flag-on/section-absent (and vice-versa) cases (review F3): no-op, no error.
   Ref: _handover/07-shop-menu-v6/review-report.md (Blocker 2, should-fix 1, F3, Q14).
   ========================================================= */
(function () {
  "use strict";

  // Idempotency: a section re-render in the Theme Editor can re-execute this script.
  // Listeners bind to document (not torn down), so guard against a double-bind.
  if (window.__zeusShopMenuBound) return;
  window.__zeusShopMenuBound = true;

  var SHOP_ID = "zeus-shop-overlay";
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  // Bridge to the mobile bottom-sheet (assets/zeus-shop-menu-mobile.js). The mobile file
  // overrides these stubs; until then they are harmless no-ops. open()/close() below are
  // module-scoped and cannot be reached from another file, so we call out via window.
  window.zeusShopMobileOpen = window.zeusShopMobileOpen || function (/* node */) {};
  window.zeusShopMobileClose = window.zeusShopMobileClose || function (/* node */) {};
  window.zeusShopDesktopOpen = window.zeusShopDesktopOpen || function (/* node */) {};

  function overlay() {
    return document.getElementById(SHOP_ID);
  }

  function isVisible(node) {
    return !!(node && node.isConnected && node.getClientRects().length);
  }

  function shopTriggers() {
    return document.querySelectorAll('[aria-controls="' + SHOP_ID + '"]');
  }

  function liveTrigger() {
    // Resolve at use time: the cached node may be detached after a header re-render.
    if (isVisible(lastTrigger)) return lastTrigger;
    var triggers = shopTriggers();
    for (var i = 0; i < triggers.length; i++) {
      if (isVisible(triggers[i])) return triggers[i];
    }
    return document.getElementById("open-shop") || lastTrigger;
  }

  function syncTriggerState(expanded) {
    Array.prototype.forEach.call(shopTriggers(), function (trigger) {
      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  function anotherOverlayOpen() {
    // Any Impact drawer (cart / search / nav) currently open and still needing the lock.
    return !!document.querySelector(".drawer[open]");
  }

  function lockScroll() {
    document.documentElement.classList.add("lock");
  }

  function unlockScroll() {
    // Coordinated: keep the lock if another overlay still relies on it (review should-fix 1).
    if (!anotherOverlayOpen()) {
      document.documentElement.classList.remove("lock");
    }
  }

  function visibleFocusables(node) {
    return Array.prototype.filter.call(node.querySelectorAll(FOCUSABLE), function (el) {
      return isVisible(el) && !el.closest("[hidden], [inert]");
    });
  }

  function open(trigger) {
    var node = overlay();
    if (!node || node.classList.contains("is-open")) return;

    if (window.ZeusModal && typeof window.ZeusModal.close === "function") {
      window.ZeusModal.close();
    }

    lastTrigger = trigger || liveTrigger();
    node.classList.add("is-open");
    syncTriggerState(true);
    lockScroll();
    window.zeusShopDesktopOpen(node);
    window.zeusShopMobileOpen(node);
    var focusables = visibleFocusables(node);
    var preferred = node.querySelector(
      window.matchMedia("(max-width:999.98px)").matches ? ".zeus-shop-menu__m-cat" : ".cat.is-active",
    );
    var first = focusables.indexOf(preferred) !== -1 ? preferred : focusables[0] || node;
    first.focus();
  }

  function close(restoreFocus) {
    var node = overlay();
    if (!node || !node.classList.contains("is-open")) return;
    node.classList.remove("is-open");
    var t = liveTrigger();
    syncTriggerState(false);
    window.zeusShopMobileClose(node);
    unlockScroll();
    if (restoreFocus !== false && isVisible(t)) t.focus();
  }

  document.addEventListener("click", function (e) {
    // Open (delegated): any element pointing at the overlay via aria-controls.
    var opener = e.target.closest('[aria-controls="' + SHOP_ID + '"]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }

    var node = overlay();
    if (!node || !node.classList.contains("is-open")) return;

    // Close button.
    if (e.target.closest("[data-zeus-shop-close]")) {
      e.preventDefault();
      close();
      return;
    }

    // Cart / search from the takeover bar: close-then-open. Close the shop (releasing our
    // lock, no focus restore) and let Impact's [aria-controls] handler open the drawer.
    // Do NOT preventDefault -- the anchor must reach the theme's body-delegated handler.
    if (e.target.closest("[data-zeus-shop-cart], [data-zeus-shop-search]")) {
      close(false);
    }
  });

  document.addEventListener("keydown", function (e) {
    var node = overlay();
    if (!node || !node.classList.contains("is-open")) return;

    if (e.key === "Escape") {
      close();
      return;
    }

    if (e.key !== "Tab") return;

    var f = visibleFocusables(node);
    if (!f.length) {
      // Nothing focusable inside the open modal: keep focus on the container, never escape.
      e.preventDefault();
      node.focus();
      return;
    }

    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;

    // Recapture: if focus has escaped the modal (or sits on the container), pull it back.
    if (!node.contains(active) || active === node) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();

/* =========================================================
   ZEUS SHOP MENU V6 -- MOBILE bottom-sheet behaviour (<1000px)
   Self-contained IIFE appended AFTER the desktop module. It does NOT redefine the
   desktop open()/close() (they are module-scoped above); instead it overrides the two
   window.zeusShopMobile* stubs the desktop module calls from inside open()/close().
   Owns: detent state machine (full/medium/peek/closed), pointer drag-to-snap, drill-in
   sub-screens (translateX), segmented axis tabs, one-open accordion. No second open
   trigger -- the header SHOP button + desktop open() is the single entry point.
   ========================================================= */
(function () {
  "use strict";

  if (window.__zeusShopMobileBound) return;
  window.__zeusShopMobileBound = true;

  var SHOP_ID = "zeus-shop-overlay";
  var MOBILE_MQ = "(max-width:999.98px)";
  var mobileQuery = window.matchMedia(MOBILE_MQ);
  var activeCategory = null;

  function isMobile() {
    return mobileQuery.matches;
  }

  // Lazily resolved refs (the section can re-render in the Theme Editor; resolve at use time).
  function overlay() {
    return document.getElementById(SHOP_ID);
  }
  function sheet() {
    var o = overlay();
    return o ? o.querySelector("[data-zsm-sheet]") : null;
  }
  function scrim() {
    var o = overlay();
    return o ? o.querySelector("[data-zsm-scrim]") : null;
  }
  function rootScreen() {
    var o = overlay();
    return o ? o.querySelector("[data-zsm-root]") : null;
  }

  var DETENTS = ["full", "medium", "peek", "closed"];

  // ----- Detent state machine -------------------------------------------------
  function setDetent(name) {
    var s = sheet();
    if (!s || DETENTS.indexOf(name) === -1) return;
    s.style.transform = ""; // clear any live drag transform; let the CSS [data-detent] rule own it
    s.dataset.detent = name;
    var sc = scrim();
    if (sc) {
      sc.style.opacity = "";
      sc.classList.toggle("is-on", name !== "closed");
    }
  }

  function showRoot() {
    var o = overlay();
    if (!o) return;
    var root = rootScreen();
    if (root) {
      root.hidden = false;
      root.removeAttribute("inert");
      root.removeAttribute("aria-hidden");
    }
    var details = o.querySelectorAll(".zeus-shop-menu__m-screen--detail");
    Array.prototype.forEach.call(details, function (d) {
      d.classList.remove("is-active");
      d.hidden = true;
      d.removeAttribute("inert");
    });
    Array.prototype.forEach.call(o.querySelectorAll(".zeus-shop-menu__m-cat"), function (c) {
      c.setAttribute("aria-expanded", "false");
    });
    activeCategory = null;
  }

  function resetRootScroll() {
    var root = rootScreen();
    var scroll = root && root.querySelector(".zeus-shop-menu__m-scroll");
    if (scroll) scroll.scrollTop = 0;
  }

  function resetSheet() {
    setDetent("closed");
    showRoot();
    resetRootScroll();
  }

  // ----- window bridge (overrides the desktop stubs) --------------------------
  window.zeusShopMobileOpen = function (/* node */) {
    if (!isMobile()) return;
    showRoot();
    resetRootScroll();
    // Open at full so langue + legal footer stay inside the viewport (ZRT-70).
    // Peek/medium remain available via drag. Defer one frame so the sheet
    // animates up from `closed` instead of snapping.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setDetent("full");
      });
    });
  };

  window.zeusShopMobileClose = function (/* node */) {
    var s = sheet();
    if (s && s.dataset.detent !== "closed") resetSheet();
  };

  // ----- Drill push -----------------------------------------------------------
  function drillTo(targetId, source) {
    var o = overlay();
    if (!o) return;
    var target = document.getElementById(targetId);
    if (!target) return;
    var root = rootScreen();
    activeCategory = source || null;
    if (activeCategory) activeCategory.setAttribute("aria-expanded", "true");
    if (root) {
      root.setAttribute("inert", "");
      root.setAttribute("aria-hidden", "true");
    }
    target.hidden = false;
    target.removeAttribute("inert");
    requestAnimationFrame(function () {
      target.classList.add("is-active");
    });
    setDetent("full");
    var back = target.querySelector(".zeus-shop-menu__m-back-btn");
    /* preventScroll: the screen is still translateX(100%) here (the is-active class lands
       on the next frame) -- without it Safari scrolls the overflow stage to reveal the
       button and leaves the whole sheet shifted left (Safari drill layout bug). */
    if (back) back.focus({ preventScroll: true });
    var stage = o.querySelector(".zeus-shop-menu__m-stage");
    if (stage) stage.scrollLeft = 0;
    var scroll = target.querySelector(".zeus-shop-menu__m-scroll");
    if (scroll) scroll.scrollTop = 0;
  }

  function backToRoot(fromScreen) {
    var source = activeCategory;
    var root = rootScreen();
    if (fromScreen) {
      fromScreen.classList.remove("is-active");
      fromScreen.setAttribute("inert", "");
    }
    if (root) {
      root.removeAttribute("inert");
      root.removeAttribute("aria-hidden");
    }
    if (source) {
      source.setAttribute("aria-expanded", "false");
      source.focus();
    }
    activeCategory = null;
    setDetent("full");
    if (!fromScreen) return;

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      fromScreen.removeEventListener("transitionend", onTransitionEnd);
      fromScreen.hidden = true;
      fromScreen.removeAttribute("inert");
    }
    function onTransitionEnd(e) {
      if (e.target === fromScreen && e.propertyName === "transform") finish();
    }

    var duration = window.getComputedStyle(fromScreen).transitionDuration;
    var durationMs = duration.indexOf("ms") > -1 ? parseFloat(duration) : parseFloat(duration) * 1000;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !durationMs) {
      finish();
      return;
    }
    fromScreen.addEventListener("transitionend", onTransitionEnd);
    window.setTimeout(finish, durationMs + 50);
  }

  // ----- Pointer drag with detent snapping ------------------------------------
  var drag = null;

  function detentTops() {
    var s = sheet();
    var h = s && s.offsetHeight ? s.offsetHeight : window.innerHeight;
    var mediumPct = 35,
      peekPct = 62;
    if (s) {
      mediumPct = parseFloat(s.dataset.detentMedium) || 35;
      peekPct = parseFloat(s.dataset.detentPeek) || 62;
    }
    var tops = { full: 0, medium: h * (mediumPct / 100), peek: h * (peekPct / 100), closed: h };
    tops.dismiss = (tops.peek + tops.closed) / 2;
    return tops;
  }

  function currentTop() {
    var s = sheet();
    if (!s) return 0;
    var d = s.dataset.detent;
    var tops = detentTops();
    if (d === "full") return tops.full;
    if (d === "medium") return tops.medium;
    if (d === "peek") return tops.peek;
    return tops.closed;
  }

  function onGrabDown(e) {
    if (!isMobile() || !e.isPrimary) return;
    var s = sheet();
    if (!s) return;
    drag = { startY: e.clientY, startTop: currentTop(), id: e.pointerId, detent: s.dataset.detent || "medium" };
    s.style.transition = "none";
    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (err) {}
  }

  function onGrabMove(e) {
    if (!drag || !e.isPrimary || e.pointerId !== drag.id) return;
    var s = sheet();
    if (!s) return;
    var tops = detentTops();
    var ty = Math.min(tops.closed, Math.max(0, drag.startTop + (e.clientY - drag.startY)));
    s.style.transform = "translateY(" + ty + "px)";
    var sc = scrim();
    if (sc) {
      var prog = 1 - Math.min(1, ty / tops.closed);
      sc.style.opacity = String(Math.max(0, prog));
    }
  }

  function cleanupDragStyles() {
    var s = sheet();
    if (s) {
      s.style.transition = "";
      s.style.transform = "";
    }
    var sc = scrim();
    if (sc) sc.style.opacity = "";
  }

  function onGrabUp(e) {
    if (!drag || !e.isPrimary || e.pointerId !== drag.id) return;
    var s = sheet();
    var tops = detentTops();
    var ty = Math.min(tops.closed, Math.max(0, drag.startTop + (e.clientY - drag.startY)));
    drag = null;
    if (!s) return;
    cleanupDragStyles();
    if (ty > tops.dismiss) {
      dismiss();
      return;
    }
    // Snap to the nearest of full / medium / peek.
    var candidates = [
      ["full", tops.full],
      ["medium", tops.medium],
      ["peek", tops.peek],
    ];
    var best = candidates[0];
    var bestDist = Math.abs(ty - best[1]);
    for (var i = 1; i < candidates.length; i++) {
      var dist = Math.abs(ty - candidates[i][1]);
      if (dist < bestDist) {
        best = candidates[i];
        bestDist = dist;
      }
    }
    setDetent(best[0]);
  }

  function onGrabCancel(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var initialDetent = drag.detent;
    drag = null;
    cleanupDragStyles();
    setDetent(initialDetent);
  }

  // ----- Dismiss (single close path, keeps desktop + mobile in sync) ----------
  function dismiss() {
    var o = overlay();
    if (!o) {
      resetSheet();
      return;
    }
    var closeBtn = o.querySelector("[data-zeus-shop-close]");
    if (closeBtn) {
      closeBtn.click(); // reuses desktop close() -> fires zeusShopMobileClose -> resetSheet, correct focus restore
    } else {
      resetSheet();
    }
  }

  // ----- Segmented axis tabs (Planches) ---------------------------------------
  function selectAxis(screen, axis) {
    var tabs = screen.querySelectorAll(".zeus-shop-menu__m-seg-tab");
    Array.prototype.forEach.call(tabs, function (t) {
      var on = t.dataset.axis === axis;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.setAttribute("tabindex", on ? "0" : "-1");
    });
    var panels = screen.querySelectorAll(".zeus-shop-menu__m-panel");
    Array.prototype.forEach.call(panels, function (p) {
      var on = p.dataset.panel === axis;
      p.classList.toggle("is-active", on);
      p.hidden = !on;
    });
    var scroll = screen.querySelector(".zeus-shop-menu__m-scroll");
    if (scroll) scroll.scrollTop = 0;
  }

  // ----- Accordion (one open per group) ---------------------------------------
  function toggleAccordion(head) {
    var group = head.closest(".zeus-shop-menu__m-acc");
    var open = head.getAttribute("aria-expanded") === "true";
    if (group && !open) {
      Array.prototype.forEach.call(group.querySelectorAll(".zeus-shop-menu__m-acc-head"), function (h) {
        h.setAttribute("aria-expanded", "false");
        var panel = document.getElementById(h.getAttribute("aria-controls"));
        if (panel) panel.hidden = true;
      });
    }
    head.setAttribute("aria-expanded", open ? "false" : "true");
    var panel = document.getElementById(head.getAttribute("aria-controls"));
    if (panel) panel.hidden = open;
  }

  // ----- Delegated event wiring (survives section re-render) -------------------
  document.addEventListener("click", function (e) {
    var o = overlay();
    if (!o || !o.classList.contains("is-open")) return;

    // Scrim tap -> dismiss via the single close path.
    if (e.target.closest("[data-zsm-scrim]")) {
      e.preventDefault();
      dismiss();
      return;
    }

    // Drill into a category detail screen.
    var cat = e.target.closest(".zeus-shop-menu__m-cat");
    if (cat && o.contains(cat)) {
      e.preventDefault();
      drillTo(cat.dataset.target, cat);
      return;
    }

    // Back to root.
    var back = e.target.closest("[data-back]");
    if (back && o.contains(back)) {
      e.preventDefault();
      backToRoot(back.closest(".zeus-shop-menu__m-screen--detail"));
      return;
    }

    // Segmented axis tab.
    var tab = e.target.closest(".zeus-shop-menu__m-seg-tab[data-axis]");
    if (tab && o.contains(tab)) {
      e.preventDefault();
      selectAxis(tab.closest(".zeus-shop-menu__m-screen"), tab.dataset.axis);
      return;
    }

    // Accordion head.
    var head = e.target.closest(".zeus-shop-menu__m-acc-head");
    if (head && o.contains(head)) {
      e.preventDefault();
      toggleAccordion(head);
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) return;
    var tab = e.target.closest(".zeus-shop-menu__m-seg-tab");
    var o = overlay();
    if (!tab || !o || !o.classList.contains("is-open") || !isMobile() || !o.contains(tab)) return;
    var screen = tab.closest(".zeus-shop-menu__m-screen");
    var tabs = Array.prototype.slice.call(screen.querySelectorAll(".zeus-shop-menu__m-seg-tab[data-axis]"));
    var index = tabs.indexOf(tab);
    if (index === -1) return;
    e.preventDefault();
    var next;
    if (e.key === "ArrowRight") next = tabs[(index + 1) % tabs.length];
    else if (e.key === "ArrowLeft") next = tabs[(index - 1 + tabs.length) % tabs.length];
    else if (e.key === "Home") next = tabs[0];
    else next = tabs[tabs.length - 1];
    selectAxis(screen, next.dataset.axis);
    next.focus();
  });

  // Escape on a drilled detail pops back to root instead of closing the overlay.
  // (Desktop Escape close still fires when we are already on root.)
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Escape") return;
      if (!isMobile()) return;
      var o = overlay();
      if (!o || !o.classList.contains("is-open")) return;
      var active = o.querySelector(".zeus-shop-menu__m-screen--detail.is-active");
      if (active) {
        e.preventDefault();
        e.stopPropagation();
        backToRoot(active);
      }
    },
    true,
  ); // capture so we pre-empt the desktop Escape->close handler

  // Pointer drag handlers bind directly to the grabber once it exists.
  function bindGrab() {
    var o = overlay();
    if (!o) return;
    var grab = o.querySelector("[data-zsm-grab]");
    if (!grab || grab.__zsmBound) return;
    grab.__zsmBound = true;
    grab.addEventListener("pointerdown", onGrabDown);
    grab.addEventListener("pointermove", onGrabMove);
    grab.addEventListener("pointerup", onGrabUp);
    grab.addEventListener("pointercancel", onGrabCancel);
    grab.addEventListener("lostpointercapture", onGrabCancel);
  }

  function syncBreakpoint() {
    var o = overlay();
    if (!o || !o.classList.contains("is-open")) return;
    if (isMobile()) {
      showRoot();
      resetRootScroll();
      setDetent("full");
      var mobileCat = o.querySelector(".zeus-shop-menu__m-cat");
      if (mobileCat) mobileCat.focus();
      return;
    }
    resetSheet();
    window.zeusShopDesktopOpen(o);
    var desktopCat = o.querySelector(".cat.is-active") || o.querySelector(".cat");
    if (desktopCat) desktopCat.focus();
  }

  if (typeof mobileQuery.addEventListener === "function") mobileQuery.addEventListener("change", syncBreakpoint);
  else mobileQuery.addListener(syncBreakpoint);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindGrab);
  } else {
    bindGrab();
  }
})();

/* =========================================================
   ZEUS SHOP MENU V6 -- DESKTOP takeover panels (>=1000px)
   Category / axis / panel switching inside .takeover__body.
   Does not touch mobile sheet handlers (.zeus-shop-menu__m-*).
   ========================================================= */
(function () {
  "use strict";

  if (window.__zeusShopDesktopBound) return;
  window.__zeusShopDesktopBound = true;

  var SHOP_ID = "zeus-shop-overlay";
  var DESKTOP_MQ = "(min-width:1000px)";

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function overlay() {
    return document.getElementById(SHOP_ID);
  }

  window.zeusShopDesktopOpen = function (node) {
    if (!isDesktop() || !node) return;
    var active = node.querySelector(".cat.is-active") || node.querySelector(".cat");
    if (active) handleCat(active, false);
  };

  document.addEventListener("click", function (e) {
    if (!isDesktop()) return;
    var node = overlay();
    if (!node || !node.classList.contains("is-open")) return;

    var cat = e.target.closest(".cat");
    if (cat && node.contains(cat)) {
      e.preventDefault();
      handleCat(cat);
      return;
    }

    var tab = e.target.closest(".axis-tab[data-axis]");
    if (tab && tab.closest("#axis-tabs") && node.contains(tab)) {
      e.preventDefault();
      handleAxis(tab.dataset.axis);
      return;
    }
  });

  function modeShop() {
    var node = overlay();
    return node ? node.querySelector("#mode-shop") : null;
  }

  function modeEd() {
    var node = overlay();
    return node ? node.querySelector("#mode-editorial") : null;
  }

  function showPanel(name) {
    var shop = modeShop();
    if (!shop) return;
    Array.prototype.forEach.call(shop.querySelectorAll(".panel"), function (p) {
      p.classList.toggle("is-active", p.dataset.panel === name);
    });
  }

  function setSpine(visible) {
    var node = overlay();
    if (!node) return;
    var spine = node.querySelector("[data-zsm-spine]");
    var display = visible ? "" : "none";
    if (spine) spine.style.display = display;
    var axisTabs = node.querySelector("#axis-tabs");
    if (axisTabs) axisTabs.style.display = display;
    var escapeLink = node.querySelector(".axis-tab--escape");
    if (escapeLink) escapeLink.style.display = display;
    var allLink = node.querySelector("#all-link");
    if (allLink) allLink.style.display = display;
  }

  function setFinder(visible) {
    var bar = overlay() && overlay().querySelector("#finder-bar");
    if (bar) bar.hidden = !visible;
  }

  function handleAxis(axis) {
    var node = overlay();
    if (!node) return;
    Array.prototype.forEach.call(node.querySelectorAll("#axis-tabs .axis-tab[data-axis]"), function (t) {
      var on = t.dataset.axis === axis;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.setAttribute("tabindex", on ? "0" : "-1");
    });
    showPanel(axis);
    setFinder(true);
  }

  // Arrow-key roving tabindex for axis-tabs (ARIA tablist pattern)
  document.addEventListener("keydown", function (e) {
    if (!isDesktop()) return;
    var node = overlay();
    if (!node || !node.classList.contains("is-open")) return;
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) return;
    var tabs = Array.prototype.slice.call(node.querySelectorAll("#axis-tabs .axis-tab[data-axis]"));
    if (!tabs.length) return;
    var active = document.activeElement;
    var idx = tabs.indexOf(active);
    if (idx === -1) return;
    e.preventDefault();
    var next;
    if (e.key === "ArrowRight") next = tabs[(idx + 1) % tabs.length];
    else if (e.key === "ArrowLeft") next = tabs[(idx - 1 + tabs.length) % tabs.length];
    else if (e.key === "Home") next = tabs[0];
    else next = tabs[tabs.length - 1];
    if (next) {
      handleAxis(next.dataset.axis);
      next.focus();
    }
  });

  function handleCat(catBtn, moveFocus) {
    var node = overlay();
    if (!node) return;
    Array.prototype.forEach.call(node.querySelectorAll(".cat"), function (c) {
      c.classList.remove("is-active");
      c.setAttribute("aria-expanded", "false");
    });
    catBtn.classList.add("is-active");
    catBtn.setAttribute("aria-expanded", "true");

    var mode = catBtn.dataset.mode;
    var cat = catBtn.dataset.cat;
    var shop = modeShop();
    var ed = modeEd();

    if (mode === "editorial") {
      setSpine(false);
      if (shop) shop.hidden = true;
      if (ed) {
        ed.hidden = false;
        Array.prototype.forEach.call(ed.querySelectorAll(".editorial__variant"), function (v) {
          v.hidden = v.dataset.editorial !== cat;
        });
        var fe = ed.querySelector(".editorial__variant:not([hidden]) .editorial__link");
        if (moveFocus !== false && fe) fe.focus();
      }
      return;
    }

    if (shop) shop.hidden = false;
    if (ed) ed.hidden = true;

    if (mode === "grid") {
      setSpine(false);
      setFinder(false);
      showPanel(cat);
      var fg = shop && shop.querySelector(".panel.is-active .board-card");
      if (moveFocus !== false && fg && fg.focus) fg.focus();
      return;
    }

    setSpine(true);
    handleAxis("niveau");
  }
})();
